import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface DetachProfileResponse extends BackendResponse {}

export interface DetachProfileParameters extends NextApiParams {
  idConcern: number;
}

export const detachProfile = withNextApi<
  DetachProfileResponse,
  DetachProfileParameters
>("/auth/DetachProfile");
